import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from 'assets/logos/bluecargo-round.svg';

interface Props {
  className?: string;
}

/**
 * Renders the round blue svg logo that links back to the app's home page
 * @returns
 */
const BlueCargoRoundLogo: React.FC<Props> = (props: Props) => {
  const { className } = props;
  return (
    <Link to="/" className={className}>
      <Logo />
    </Link>
  );
};
BlueCargoRoundLogo.displayName = 'BlueCargoRoundLogo';

export default BlueCargoRoundLogo;
